import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { __DEV__ } from "@chakra-ui/utils";
import * as React from "react";
import CSSTransition from "react-transition-group/Transition";
export function Transition(props) {
  var styles = props.styles,
      inProp = props["in"],
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 150 : _props$timeout,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? "all " + timeout + "ms ease-in-out" : _props$transition,
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["styles", "in", "timeout", "transition", "children"]);

  var getStyle = function getStyle(state) {
    return _extends({}, styles.init, {
      transition: transition
    }, styles[state]);
  };

  return /*#__PURE__*/React.createElement(CSSTransition, _extends({
    appear: true,
    unmountOnExit: true,
    "in": inProp,
    timeout: timeout
  }, rest), function (state) {
    return children(getStyle(state));
  });
}

if (__DEV__) {
  Transition.displayName = "Transition";
}